import LocalizedStrings from 'localized-strings';

export const locales = new LocalizedStrings({
  en: {
    error: 'An error occurred. Please try again.',
    neutral: 'Neutral rate',
    sidebar: {
      differentRates: {
        neutral: '**the neutral rate** for a single person with no children;',
        personalized: '**the personalized rate**: shown on your tax form;',
        question:
          'What are the different possible rates used to calculate income tax?',
        standard:
          '**the standard rate scale**: the "official" formula used by the tax authorities to calculate your tax rate.',
        threeTaxes: 'There are 3 different rates:',
      },
      taxNeutral: {
        info: "If you don't know what your personalized tax rate is, or if you'd like to know what your withholding tax will be if you choose not to inform your employer of your rate, the neutral rate calculation corresponds to taxation for a single person with no children and no other income or expenses.",
        question: 'What is the neutral rate?',
      },
      taxPersonalized: {
        info: 'You can directly use the customized rate provided by the authorities to calculate your tax. To find out, visit your personal tax space',
        question: 'What is a personalized tax rate?',
      },
      taxStandard: {
        info: 'It refers to the "official" tax calculation, the one used by the tax authorities to calculate your tax rate.',
        question: 'What is the standard scale?',
      },
      title: 'Learn more…',
    },
    title: 'Your tax rate',
  },
  fr: {
    error: 'Une erreur est survenue. Veuillez réessayer.',
    neutral: 'Taux neutre',
    sidebar: {
      differentRates: {
        neutral: '**le taux neutre** : pour un célibataire sans enfants ;',
        personalized:
          '**le taux personnalisé** : indiqué sur votre avis d’imposition ;',
        question:
          'Quels sont les différents taux possibles pour calculer l’impôt sur le revenu ?',
        standard:
          '**le barème standard** : la formule "officielle" utilisée par l’administration fiscale pour obtenir le taux d’imposition.',
        threeTaxes: 'Il existe 3 taux :',
      },
      taxNeutral: {
        info: 'Si vous ne connaissez pas votre taux personnalisé ou si vous voulez connaître votre impôt à la source dans le cas où vous avez choisi de ne pas communiquer votre taux à l’employeur, le calcul au taux neutre correspond à une imposition pour un·e célibataire sans enfants et sans autres revenus / charges.',
        question: 'Qu’est-ce que le taux neutre ?',
      },
      taxPersonalized: {
        info: 'Vous pouvez utiliser directement le taux personnalisé communiqué par l’administration fiscale pour calculer votre impôt. Pour le connaître, vous pouvez-vous rendre sur votre espace fiscal personnel.',
        question: 'Qu’est-ce que le taux personnalisé ?',
      },
      taxStandard: {
        info: 'Il correspond au calcul "officiel" de l’impôt, celui sur lequel l’administration fiscale se base pour calculer votre taux d’imposition.',
        question: 'Qu’est-ce que le barème standard ?',
      },
      title: 'En savoir plus…',
    },
    title: 'Votre taux d’imposition',
  },
} as const);
